import { Component, OnInit } from "@angular/core";
import { NbIconLibraries } from "@nebular/theme";
import { AuthService } from "src/app/pages/service/auth.service";
import { Country } from "src/app/pages/models/interface.model";
import { ProfileService } from "src/app/dashboard/services/profile.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import swal from "sweetalert2";
import {
  ProfileInfo,
  ProfileForm,
  AddressForm,
} from "src/app/dashboard/model/interface.model";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.css"],
})
export class UserProfileComponent implements OnInit {
  countryList: Country[] = null;
  profileImg: string | ArrayBuffer = "assets/images/profile.png";
  user: ProfileInfo = null;

  profileUpdateForm: FormGroup;
  addressUpdateForm: FormGroup;

  profileUpdateLoading: boolean = false;
  profilePicUploadLoading: boolean = false;
  addressUpdateLoading: boolean = false;

  selectedProfileImage: File = null;

  constructor(
    private iconLibraries: NbIconLibraries,
    private auth: AuthService,
    private profile: ProfileService
  ) {
    this.iconLibraries.registerFontPack("font-awesome");
  }

  ngOnInit() {
    this.auth.getCountryList().subscribe((countries) => {
      this.countryList = countries;
    });

    this.profileUpdateForm = new FormGroup({
      fullname: new FormControl(null, [Validators.required]),
      dob: new FormControl(null, [Validators.required]),
      gender: new FormControl("male", [Validators.required]),
      profile_img_upload: new FormControl(""),
    });

    this.addressUpdateForm = new FormGroup({
      address_line: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      city: new FormControl(null, [Validators.required]),
      country: new FormControl(null, [Validators.required]),
      zipcode: new FormControl(null, [Validators.required]),
    });

    this.getUserInfo();
  }

  getUserInfo() {
    this.profile.userInfoBasic().subscribe(
      (response) => {
        this.user = response.data;
        if (this.user.profileImg) {
          this.profile
            .getProfileImage(this.user.profileImg)
            .subscribe((response) => {
              let reader = new FileReader();
              reader.addEventListener(
                "load",
                () => {
                  this.profileImg = reader.result;
                },
                false
              );

              if (response) {
                reader.readAsDataURL(response);
              }
            });
        }

        if (this.profileUpdateForm) {
          this.profileUpdateForm.patchValue({
            fullname: this.user.fullname,
            dob: this.user.dob,
            gender: this.user.gender || "male",
          });
        }

        if (this.addressUpdateForm) {
          this.addressUpdateForm.patchValue({
            address_line: this.user.address,
            state: this.user.state,
            city: this.user.city,
            country: {
              name: this.user.country,
              dial_code: this.user.dialCode,
            },
            zipcode: this.user.zipcode,
          });
        }
      },
      (error) => {}
    );
  }

  selectedFile(event: { target: { files: File[] } }) {
    this.selectedProfileImage = <File>event.target.files[0];
  }

  changeProfilePic() {
    const fd = new FormData();
    fd.append(
      "image",
      this.selectedProfileImage,
      this.selectedProfileImage.name
    );
    this.profile.uploadProfilePic(fd).subscribe(
      (response) => {
        if (response.request_status) {
          swal.fire("Profile Image Uploaded", "", "success");
          this.selectedProfileImage = null;
          this.profileUpdateForm.patchValue({
            profile_img_upload: null,
          });
          this.getUserInfo();
        } else {
          swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }

  cancelUploadImage() {
    this.selectedProfileImage = null;
    this.profileUpdateForm.patchValue({
      profile_img_upload: null,
    });
  }

  updateProfile() {
    this.profileUpdateLoading = true;
    let formData: ProfileForm = {
      name: this.profileUpdateForm.value.fullname,
      dob: this.profileUpdateForm.value.dob,
      gender: this.profileUpdateForm.value.gender,
    };

    this.profile.updateProfile(formData).subscribe(
      (response) => {
        this.profileUpdateLoading = false;
        if (response.request_status) {
          swal.fire("Profile Updated", "", "success");
        } else {
          swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        this.profileUpdateLoading = false;
        swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }

  updateAddress() {
    this.addressUpdateLoading = true;
    let formData: AddressForm = {
      address_line: this.addressUpdateForm.value.address_line,
      state: this.addressUpdateForm.value.state,
      city: this.addressUpdateForm.value.city,
      zipcode: this.addressUpdateForm.value.zipcode,
      country: this.addressUpdateForm.value.country.name,
      dial_code: this.addressUpdateForm.value.country.dial_code,
    };

    this.profile.updateAddress(formData).subscribe(
      (response) => {
        this.addressUpdateLoading = false;
        if (response.request_status) {
          swal.fire("Address Updated", "", "success");
        } else {
          swal.fire("", response.error_message, "warning");
        }
      },
      (error) => {
        this.addressUpdateLoading = false;
        swal.fire(
          "Network Error",
          error.error.error_message || "something went wrong, try again later",
          "error"
        );
      }
    );
  }
}
